import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { VerifyEmailView } from "@/components/VerifyEmailView";

const searchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute("/verify")({
  validateSearch: (raw): { token?: string } => searchSchema.parse(raw),
  component: function VerifyPage() {
    const { token } = Route.useSearch();
    return <VerifyEmailView token={token ?? null} />;
  },
});
